/**
 * Yonristic Alerts & Confirmations Engine
 * A modular and pluggable system for variant warnings and checkout interceptions.
 */

window.YonristicAlertsRegistry = [
  {
    handles: [
      'corvette-c8-stingray-afm-z-pipe-exhaust-system-vanta-edition-yonristic-performance', 
      'corvette-c8-stingray-afm-r-pipe-exhaust-system-vanta-edition-yonristic-performance', 
      'chevrolet-corvette-c8-afm-vanta-edition-exhaust-system-yonristic-performance'
    ],
    optionMatch: 'NPP Valves', // Partial or exact match for option name
    inlineWarningHTML: `
      <div class="yon-inline-alert">
        <svg class="yon-inline-alert-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        <div class="yon-inline-alert-content">
          <h5 class="yon-inline-alert-title">Fitment Notice</h5>
          <div class="yon-inline-alert-item">
            <span class="yon-inline-alert-bullet"></span>
            <strong>Have Z51 or factory NPP valves?</strong> Select <span class="yon-inline-alert-strong">OEM Factory Control</span>
          </div>
          <div class="yon-inline-alert-item">
            <span class="yon-inline-alert-bullet"></span>
            <strong>No factory valves?</strong> Select <span class="yon-inline-alert-strong">Remote Control</span>
          </div>
          <div class="yon-inline-alert-warning">
            ⚠️ Incorrect configuration will result in an exhaust that cannot be installed.
            <div class="yon-inline-alert-disclaimer">
              Yonristic is not responsible for any issues resulting from an incorrect configuration selection due to customer error. Returns and refunds will not be accepted.
            </div>
          </div>
        </div>
      </div>
    `,
    modal: {
      step1Title: "Confirm NPP Valves",
      step1Desc: "To ensure a smooth installation, please confirm you have selected the correct option.",
      step2Title: "Confirmed!",
      step2Desc: "Due to browser payment security, we cannot auto-redirect you. <br><br>Please click the <b>Buy with Shop</b> button one more time to proceed to checkout."
    }
  }
];

document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  let activeConfig = null;

  // 1. Find matching config based on product handle
  for (const config of window.YonristicAlertsRegistry) {
    const isMatch = config.handles.some(handle => currentPath.includes('/products/' + handle));
    if (isMatch) {
      activeConfig = config;
      break;
    }
  }

  if (!activeConfig) return;

  // 2. Inject Inline Warning HTML into the matching slot
  const slots = document.querySelectorAll('.yon-variant-alerts-slot');
  let optionContainerMatched = false;
  
  slots.forEach(slot => {
    const optName = slot.getAttribute('data-option-name') || '';
    if (optName.toLowerCase().includes(activeConfig.optionMatch.toLowerCase())) {
      slot.innerHTML = activeConfig.inlineWarningHTML;
      optionContainerMatched = true;
    }
  });

  // If no option slot matched or wasn't found, we don't need to intercept
  if (!optionContainerMatched) return;

  // 3. Inject Modal HTML dynamically
  if (!document.getElementById('yonristic-alerts-modal')) {
    const modalHtml = `
      <div id="yonristic-alerts-modal" class="yon-modal-overlay">
        <div class="yon-modal-box">
          
          <div id="yon-modal-step1" class="yon-modal-step">
            <svg class="yon-modal-icon-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
            <h3 class="yon-modal-title">${activeConfig.modal.step1Title}</h3>
            <p class="yon-modal-desc">${activeConfig.modal.step1Desc}</p>
            <div class="yon-modal-selection-box">
              <span class="yon-modal-selection-label">Your current selection:</span>
              <strong id="yonristic-alerts-selection" class="yon-modal-selection-value"></strong>
            </div>
            <div class="yon-modal-actions">
              <button id="yonristic-alerts-cancel" type="button" class="yon-btn yon-btn-cancel">Cancel</button>
              <button id="yonristic-alerts-confirm" type="button" class="yon-btn yon-btn-confirm">Confirm</button>
            </div>
          </div>

          <div id="yon-modal-step2" class="yon-modal-step" style="display: none;">
            <svg class="yon-modal-icon-success" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <h3 class="yon-modal-title">${activeConfig.modal.step2Title}</h3>
            <p class="yon-modal-desc yon-modal-desc-step2">${activeConfig.modal.step2Desc}</p>
            <button id="yonristic-alerts-close" type="button" class="yon-btn yon-btn-close">Got it</button>
          </div>

        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHtml);
  }

  // 4. Attach Event Listeners to Form
  const modal = document.getElementById('yonristic-alerts-modal');
  const step1 = document.getElementById('yon-modal-step1');
  const step2 = document.getElementById('yon-modal-step2');
  const cancelBtn = document.getElementById('yonristic-alerts-cancel');
  const confirmBtn = document.getElementById('yonristic-alerts-confirm');
  const closeBtn = document.getElementById('yonristic-alerts-close');
  const selectionText = document.getElementById('yonristic-alerts-selection');
  
  let pendingTarget = null;
  let isConfirmed = false;

  cancelBtn.addEventListener('click', function() {
    modal.style.display = 'none';
    pendingTarget = null;
  });

  closeBtn.addEventListener('click', function() {
    modal.style.display = 'none';
  });

  confirmBtn.addEventListener('click', function() {
    isConfirmed = true;
    
    var isMoreOptions = pendingTarget && pendingTarget.closest('.shopify-payment-button__more-options');
    var isAccelerated = pendingTarget && pendingTarget.closest('.shopify-payment-button, shop-pay-button, shopify-accelerated-checkout, shopify-payment-terms');
    
    if (!isMoreOptions && isAccelerated) {
      // Dynamic checkout requires physical click (Step 2)
      step1.style.display = 'none';
      step2.style.display = 'block';
      pendingTarget = null;
      setTimeout(function() { isConfirmed = false; }, 15000);
    } else {
      // Standard ATC or More Options
      modal.style.display = 'none';
      if (pendingTarget) {
        if (typeof pendingTarget.click === 'function') {
          pendingTarget.click();
        } else {
          pendingTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        }
        pendingTarget = null;
      }
      setTimeout(function() { isConfirmed = false; }, 1000);
    }
  });

  // Intercept the form click
  const forms = document.querySelectorAll('.t4s-form__product, form[action="/cart/add"]');
  forms.forEach(form => {
    form.addEventListener('click', function(e) {
      var isATC = e.target.closest('button[type="submit"], .t4s-product-form__submit');
      var isPaymentBtn = e.target.closest('.shopify-payment-button__button, .shopify-payment-button__more-options, .shopify-payment-button, shop-pay-button, shopify-accelerated-checkout, shopify-payment-terms');
      
      if (!isATC && !isPaymentBtn) return;
      if (isConfirmed) return;
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Determine selected value specifically for the matching option container
      let selectedValue = "Unknown";
      
      // We look for an option container matching the option match
      const allOptionContainers = form.querySelectorAll('.t4s-swatch__option, .t4s-swatch');
      allOptionContainers.forEach(container => {
        const titleSpan = container.querySelector('.t4s-swatch__title');
        if (titleSpan && titleSpan.innerText.toLowerCase().includes(activeConfig.optionMatch.toLowerCase())) {
          var activeItem = container.querySelector('.is--selected');
          if (activeItem) {
            selectedValue = activeItem.getAttribute('data-value') || activeItem.innerText;
          } else {
            var currentValSpan = container.querySelector('[data-current-value]');
            if (currentValSpan) selectedValue = currentValSpan.innerText;
          }
        }
      });
      
      selectionText.innerText = selectedValue.trim();
      pendingTarget = isPaymentBtn || isATC;
      
      step1.style.display = 'block';
      step2.style.display = 'none';
      modal.style.display = 'flex';
    }, true); // use capture phase
  });
});
